import { createContext, useEffect, useState } from "react";
import { TableContextValue, TableProviderProps, MergedTableStrType } from "./types";
import { MergedColumnType } from "../../components/ui/table/utils/types";

export const TableContext = createContext<TableContextValue>({
  buttonStr: "",
  setButtonStr: () => {},
  checkboxStr: "",
  setCheckboxStr: () => {},
  boxStr: [],
  setBoxStr: () => {},
  onBoxStrChange: () => {},
  url: "",
  setUrl: () => {},
  rowData: {},
  setRowData: () => {},
  numenclatureId: undefined,
  setNumenclatureId: () => {},
  contextTableData: [],
  setContextTableData: () => {},
  visibleColumn: false,
  setVisibleColumn: () => {},
  // record: {},
  // setRecord: () => {},
  // formIds: {},
  // setFormIds: () => {},
});

export function TableProvider({ children }: TableProviderProps) {
  const [buttonStr, setButtonStr] = useState<string | undefined>("");
  const [checkboxStr, setCheckboxStr] = useState<string | undefined>("");
  const [boxStr, setBoxStr] = useState<MergedTableStrType[]>([]);
  const [url, setUrl] = useState("");
  const [rowData, setRowData] = useState({});
  const [numenclatureId, setNumenclatureId] = useState(undefined);
  const [contextTableData, setContextTableData] = useState<MergedColumnType[]>([]);
  const [visibleColumn, setVisibleColumn] = useState(false);
  // const [record, setRecord] = useState({});
  // const [formIds, setFormIds] = useState({});

  const onBoxStrChange = (params: {
    url: string, 
    formName: string, 
    checkboxStr?: string | undefined, 
    buttonStr?: string | undefined, 
    radioboxStr?: string | undefined}) => {
    console.log("BOX STR ", boxStr)

    if (!params?.url) return;
    if(boxStr?.length > 0 && boxStr.find((item) => item.url === params.url && item.formName === params.formName)) {
      if(params?.buttonStr == null && params?.checkboxStr == null && params?.radioboxStr == null) {
        setBoxStr(boxStr.filter((item) => item.url !== params.url));
    console.log("BOX STR ", boxStr)

        return;
      }
      setBoxStr((prev) => prev.map((item) => (item.url === params.url && item.formName === params.formName ? {
        ...item,
        ...(params.buttonStr != null? {buttonStr: params.buttonStr?.trim() || ""} : {}),
        ...(params.checkboxStr != null? {checkboxStr: params.checkboxStr?.trim() || ""} : {}),
        ...(params.radioboxStr != null? {radioboxStr: params.radioboxStr?.trim() || ""} : {}),
      } : item)));
    console.log("BOX STR ", boxStr)

      return;
    }else {
      setBoxStr([
        ...(boxStr || []),
        { 
          url: params.url, 
          formName: params.formName, 
          ...(params.buttonStr != null? {buttonStr: params.buttonStr?.trim() || ""} : {}),
          ...(params.checkboxStr != null? {checkboxStr: params.checkboxStr?.trim() || ""} : {}),
          ...(params.radioboxStr != null? {radioboxStr: params.radioboxStr?.trim() || ""} : {}),
        },
      ]);
    }
    console.log("ROW DATA ", rowData)
  };

  return (
    <TableContext.Provider
      value={{
        buttonStr,
        setButtonStr,
        checkboxStr,
        setCheckboxStr,
        boxStr,
        setBoxStr,
        onBoxStrChange,
        url,
        setUrl,
        rowData,
        setRowData,
        numenclatureId,
        setNumenclatureId,
        contextTableData,
        setContextTableData,
        visibleColumn, 
        setVisibleColumn,
        // record,
        // setRecord,
        // formIds,
        // setFormIds,
      }}
    >
      {children}
    </TableContext.Provider>
  );
}
